import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ButtonSpinner from './ButtonSpinner';

const Button = ({ type, classes, children, size, disabled, onClick, loading, spinColor, faux, onMouseEnter, onMouseLeave, value, tabIndex, pulse, style }) => {
  // If we set the 'faux' prop then we don't want to add the 'btn' class
  const btnClass = classNames(`btn--${size}`, classes, {
    btn: !faux,
    'btn--loading': loading,
    'btn--pulse': pulse,
  });

  const preventFocus = (e) => {
    e.currentTarget.blur();
    if (onClick) onClick(e);
  };

  return (
    <button
      type={type || 'button'}
      className={btnClass}
      disabled={disabled}
      onClick={preventFocus}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      value={value}
      tabIndex={tabIndex}
      style={style}
    >
      {children}
      <ButtonSpinner loading={loading} color={spinColor} size={size} />
    </button>
  );
};

Button.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  spinColor: PropTypes.string,
  type: PropTypes.string,
  faux: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  value: PropTypes.string,
  tabIndex: PropTypes.number,
  pulse: PropTypes.bool,
  style: PropTypes.object,
};

export default Button;



// WEBPACK FOOTER //
// ./library/app/components/Global/Buttons/Button.js